module.exports = __webpack_public_path__ + "img/data-bg.14af8873.png";